import type { Node } from "@react-types/shared";
import type { ReactElement } from "react";
import { useRef } from "react";
import { useTab as useAriaTab } from "react-aria";
import type { TabListState } from "react-stately";

/**
 * Used to build the TabBar items, the tabs
 * @param state Provided by useTabList
 * @param item The current TabBar Node, the item from `state.collection` list
 */
export const useTab = <T extends HTMLElement, U = ReactElement>(state: TabListState<U>, item: Node<U>) => {
  const { key, rendered } = item;
  const ref = useRef<T>(null);
  const { tabProps } = useAriaTab({ key }, state, ref);
  const isSelected = state.selectedKey === key;
  const isDisabled = state.disabledKeys.has(key);

  return { ref, rendered, tabProps, isSelected, isDisabled };
};
